module.exports = __webpack_public_path__ + "media/components/leaflet/static/placeholder-92dfd3c8b9c5ceeb4bc3f6cbbf6e7e32.jpg";